import React, { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import axios from 'axios';
import { FiPackage, FiUser, FiMapPin, FiClock, FiTruck } from 'react-icons/fi';
import './Pedido.css';
import { getPedido } from 'utils/LaravelApi/LaravelAPI';

const Pedido = () => {
  const { uuid } = useParams();
  const [order, setOrder] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    const fetchOrder = async () => {
            try {
                const response = await getPedido(uuid);
                console.log(response.data);
                setOrder(response.data);
            } catch (err) {
                setError(err.response?.data?.message || 'Error al cargar el pedido');
            } finally {
                setLoading(false);
            }
        };

    fetchOrder();
  }, [uuid]);

  if (loading) return (
    <div className="loading-container">
      <div className="loading-spinner"></div>
      <p>Cargando información del pedido...</p>
    </div>
  );

  if (error) return (
    <div className="error-container">
      <div className="error-icon">!</div>
      <h2>No pudimos encontrar tu pedido</h2>
      <p>{error}</p>
      <button onClick={() => window.location.reload()}>Reintentar</button>
    </div>
  );

  return (
    <div className="order-container">
      <header className="order-header">
        <h1><FiPackage /> Detalles de tu pedido</h1>
        <div className="order-meta">
          <span className="order-status">{order.status}</span>
          <span className="order-date"><FiClock /> {order.date}</span>
        </div>
      </header>

      <div className="order-grid">
        {/* Sección de información del cliente */}
        <section className="customer-info card">
          <h2><FiUser /> Información del cliente</h2>
          <div className="info-grid">
            <div>
              <h3>Nombre</h3>
              <p>{order.name}</p>
            </div>
            <div>
              <h3>Email</h3>
              <p>{order.email}</p>
            </div>
            <div>
              <h3>Teléfono</h3>
              <p>{order.phone}</p>
            </div>
          </div>
        </section>

        {/* Sección de dirección */}
        <section className="address-info card">
          <h2><FiMapPin /> Dirección de envío</h2>
          <address>
            <p>{order.street}</p>
            <p>Col. {order.colony}</p>
            <p>{order.city}, {order.state}</p>
            <p>C.P. {order.postal_code}</p>
            <p>{order.country}</p>
            {order.reference_address && (
              <div className="reference">
                <h3>Referencia:</h3>
                <p>{order.reference_address}</p>
              </div>
            )}
          </address>
        </section>

        {/* Resumen del pedido */}
        <section className="order-summary card">
          <h2>Resumen del pedido</h2>
          <div className="summary-grid">
            <div>
              <h3>Subtotal</h3>
              <p>${order.products.reduce((sum, p) => sum + (p.price * p.quantity), 0).toFixed(2)}</p>
            </div>
            <div className="total-row">
              <h3>Total</h3>
              <p>${order.products.reduce((sum, p) => sum + (p.price * p.quantity), 0).toFixed(2)}</p>
            </div>
          </div>
        </section>

        {/* Seguimiento (si está disponible) */}
        {order.numero_seguimiento && (
          <section className="tracking-info card">
            <h2><FiTruck /> Seguimiento de envío</h2>
            <div className="tracking-details">
              <p><strong>Paquetería:</strong> {order.paqueteria}</p>
              <p><strong>Número de seguimiento:</strong> {order.numero_seguimiento}</p>
              <button className="tracking-button">Rastrear envío</button>
            </div>
          </section>
        )}

        {/* Sección de productos - OCUPA TODO EL ANCHO */}
        <section className="products-section card">
          <h2>Productos ({order.products.length})</h2>
          <div className="products-list">
            {order.products.map((product, index) => (
              <div key={index} className="product-item">
                <div className="product-info">
                  <h3>{product.name}</h3>
                  {product.description && <p className="product-description">{product.description}</p>}
                </div>
                <div className="product-meta">
                  <span className="product-quantity">{product.quantity} ×</span>
                  <span className="product-price">${product.price.toFixed(2)}</span>
                  <span className="product-total">${(product.quantity * product.price).toFixed(2)}</span>
                </div>
              </div>
            ))}
          </div>
        </section>
      </div>

      <footer className="order-footer">
        <p>¿Necesitas ayuda? <a href="mailto:soporte@afinazone.com">Contáctanos</a></p>
        <p className="copyright">© {new Date().getFullYear()} Afinazone. Todos los derechos reservados.</p>
      </footer>
    </div>
  );
};

export default Pedido;